/*
 * @Author: chengyu
 * @Date: 2022-09-22 16:18:55
 * @Description: 逆地理编码
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ServiceTypeEnum } from '../../enums';
import { MapRgcStatusEnum } from '../../enums/ubt';
import { fetchWrap } from '../../request/fetch';
import { lbsRequest } from '../../request/lbs';
import { getGeoCacheOptions } from '../../utils';
import { isNetworkError } from '../../utils/is';
import { mapError } from '../../utils/logger';
import { ubtRgcStatistics } from '../../utils/ubt';
/**
 * 逆地理编码
 * @description https://hellobike.yuque.com/rtyizx/ggpmnl/tol4kn
 * @param query
 * @param options
 */
function reGeoCodingSearch(query, options) {
    var appKey = options.appKey, secretKey = options.secretKey, cache = options.cache, context = options.context, fallbackRegeo = options.fallbackRegeo, serveSort = options.serveSort, method = options.method, onBefore = options.onBefore;
    var startTime = new Date().getTime();
    var ubtRgcCommonOptions = {
        appKey: appKey,
        startTime: startTime,
        lbsStartTime: startTime,
        type: ServiceTypeEnum.HELLO,
    };
    return fetchWrap(lbsRequest, {
        context: context,
        serveSort: serveSort,
        method: method,
        params: {
            method: 'reGeoCodingSearch',
            action: 'hello.lbs.code.regeo',
            appKey: appKey,
            secretKey: secretKey,
            query: query,
        },
        mapOptions: options,
        fallbackRegeo: fallbackRegeo,
        cache: getGeoCacheOptions(cache),
        serviceType: ServiceTypeEnum.HELLO,
        onBefore: onBefore,
        onSuccess: function (params, response) {
            ubtRgcStatistics(__assign(__assign({}, ubtRgcCommonOptions), { params: params, 
                /**
                 * `response`是经过处理之后的，lbs格式数据
                 */
                response: response, status: MapRgcStatusEnum.lbsSuccess }));
        },
        onError: function (e) {
            var _a, _b;
            try {
                if (isNetworkError(e)) {
                    ubtRgcStatistics(__assign(__assign({}, ubtRgcCommonOptions), { params: (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.request) === null || _b === void 0 ? void 0 : _b.body, 
                        /**
                         * `fetchData`是经过`transformResponse`的结果
                         */
                        response: e.fetchData, status: MapRgcStatusEnum.lbsError }));
                }
            }
            catch (e) {
                mapError('hello.lbs.code.regeo onError', e);
            }
        },
    });
}
export default reGeoCodingSearch;
//# sourceMappingURL=data:application/json;base64,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